import { apiSlice } from "infra/store/apiSlice";

import { combineReducers } from "@reduxjs/toolkit";

export const appReducer = combineReducers({
  api: apiSlice.reducer,
});
